import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { api } from '../URL/api-url';
import { LoginService } from '../services/login.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  changepasswordform: any = new FormGroup({
    newpassword: new FormControl(''),
    confirmpassword: new FormControl(''),
    username: new FormControl('')
  });
  token: any = ''
  userloggedin: boolean = false;
  parentlogo: any;

  lang = {
    Reset_Password: 'Reset Password',
    Enter_New_Password: 'Enter New Password',
    Confirm_Password: 'Confirm Password',
    Please_enter_password: 'Please enter new password.',
    Password_must_be_at_least_8_characters: 'Password must be at least 8 characters.',
    Password_must_not_exceed_40_characters: 'Password must not exceed 40 characters.',
    Please_enter_confirm_password: 'Please enter confirm password.',
    Passwords_did_not_match: 'Passwords did not match.',
    Submit: 'Submit'
  };
  copyright: any;
  username: any;
  customerId: any;
  welcomeMessage:any;
  firstname: any;
  logo: any;
  currClient: any = '';

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private loginService: LoginService,
  ) { }

  ngOnInit(): void {
    setTimeout(()=>{
      sessionStorage.setItem("timeStamp", new Date().getTime().toString());
    },1000)
    this.username = this.route.snapshot.queryParams['username'];
    this.firstname = this.route.snapshot.queryParams['name'];
    if(this.firstname){
      this.firstname = this.firstname
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
    }
    this.welcomeMessage = 'Welcome'
    this.initForm();
    this.openModal();
    this.copyright = new Date().getFullYear()
    this.token = this.route.snapshot.queryParams['token'];
    this.changepasswordform.get('username')?.disable();
    console.log(this.username)


    const client:any = this.route.snapshot.paramMap.get('client');

    if(client){
      this.currClient = client
      sessionStorage.setItem('currClient', client)
      this.loginService.getClientLogos().subscribe(
        (response: any) => {
          if (response['statusCode'] == 200 || response['status'] == 200) {
             if (response?.data?.clientLogos && response?.data?.clientLogos[client]) {
              this.parentlogo = response?.data?.clientLogos[client];
            }
          }
        },
        (error) => {
          Swal.fire({ title: 'Info', text: error.error.error.message });
        }
      );
    }

    if(this.username){
      this.loginService.checkUserLoggedInForFirstTime(this.username).subscribe(
        (response: any) => {
          if (response['statusCode'] == 200 || response['status'] == 200) {
            if(response['firstTimeUser']){
              this.welcomeMessage += ', '
            }else{
              this.welcomeMessage += ' back, '
            }
          }
        },
        (error) => {
          Swal.fire({ title: 'Info', text: error.error.error.message });
        }
      );



      // check the username and customerlogo

      this.loginService.getCustomerLogo(this.username).subscribe(
        (response: any) => {
          if (response['statusCode'] == 200 || response['status'] == 200) {
            if(!!response?.data?.logo){
              this.parentlogo = response?.data?.logo;
              sessionStorage.setItem("logoutWithUsername", 'true')
              sessionStorage.setItem("username", this.username)
            }
          }
        },
        (error) => {
          Swal.fire({ title: 'Info', text: error.error.error.message });
        }
      );
    }
  }

  initForm(): void {
    this.changepasswordform = this.fb.group({
      username: [this.username],
      newpassword: ['', [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(40)  
      ]],
      confirmpassword: ['', [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(40),
        this.passwordMatchValidator
      ]]
    });
  }

  passwordMatchValidator(control: any) {
    const newpassword = control?.parent?.get('newpassword')?.value;
    if (newpassword && control.value !== newpassword) {
      return { confirmedValidator: true };
    }
    return null;
  }

  async getIPAddress() {
    let ipAddress = 'NA';
  
    try {
      const response = await fetch('https://jsonip.com', { mode: 'cors' });
      const data = await response.json();
      ipAddress = data.ip;
    } catch (error) {
      try {
        const fallbackResponse = await fetch('https://api.groupbenefitz.ca/api/admin/app2');
        const fallbackData = await fallbackResponse.json();
        ipAddress = fallbackData?.data?.ip || 'NA';  // Use fallback ip if available
  
        // Check if IP is a local address
        if (ipAddress?.includes('127')) {
          ipAddress = 'NA';
        }
      } catch (err) {
        console.log('Error with fallback API:', err);
        ipAddress = 'NA';
      }
    }
  
    return ipAddress;
  }
  

  async SubmitChangePassword() {
    if (this.changepasswordform.valid) {
      const newpassword = this.changepasswordform.get('newpassword')?.value;
      const obj = {
        token: this.token,
        newpassword: newpassword,
        // ipAddress: await this.getIPAddress()
        ipAddress: sessionStorage.getItem('ipaddress') ?? 'NA'
      }
      console.log({obj})
      this.http.post(api.url + '/member/reset-password', obj ).subscribe((response: any) => {
          if (response.status == 200) {
            Swal.fire({
              allowOutsideClick: false,
              title: 'Info',
              text: response.message
            }).then((result) => {
              if (result.isConfirmed) {
                console.log('this.userloggedin',this.userloggedin===true)
                if (this.userloggedin===true) {
                  this.closeChangepassmodel();
                  if(this.currClient){
                    this.router.navigate([`${this.currClient}/home`]);
                  }else{
                    this.router.navigate(['home']);
                  }
                } else {
                  this.closeChangepassmodel();
                  sessionStorage.clear()
                  if(this.username){
                    this.submit_v2();
                  }else{
                     if(this.currClient){
                      this.router.navigate([`${this.currClient}/login`]);
                    }else{
                      this.router.navigate(['login']);
                    }
                  }
                }
              }
            });
            
          }
          else {
            Swal.fire({ allowOutsideClick: false, title: 'Info', text: response.message })
          }
        }, (error) => {
          Swal.fire({ allowOutsideClick: false, title: 'Info', text: error.message })
        })
    }
  }

  openModal(): void {
    const modalElement = document.getElementById('changepassword') as HTMLElement;
    if (modalElement) {
      modalElement.classList.add('show');
      modalElement.setAttribute('aria-hidden', 'false');
      modalElement.style.display = 'block';
    }
  }


    submit_v2() {
      let inputData={
        "username":this.username,
        "password":this.changepasswordform.get('newpassword')?.value
      }
  
      console.log(inputData)
  
      this.loginService.login(inputData).subscribe(
        (data: any) => {
          if (data['status'] == 200 || data['statusCode'] == 200) {
            sessionStorage.setItem('login', 'true');
            sessionStorage.setItem('loginTime', data.data.lastLogin);
            sessionStorage.setItem('accessToken', data.token);
            sessionStorage.setItem('customerId', data.data.customerId);
            sessionStorage.setItem('customerName', data.data.userName);
            sessionStorage.setItem('coproratelogo', data.data.corporateLogo);
            if (data && data?.settings && data?.settings?.length > 0) {
              sessionStorage.setItem("fileSize", data?.settings[0]?.settingsValue);
            }
  
            this.customerId = data.data.customerId;
             if(this.currClient){
                this.router.navigate([`${this.currClient}/home`]);
              }else{
                this.router.navigate(['home']);
              }
          } else if (data['status'] == 206 || data['statusCode'] == 206) {
            $('#activationlink').show();
          }
        },
        (error) => {
          Swal.fire({ title: 'Info', text: error.error.message });
        }
      );
    }
 
  closeChangepassmodel(): void {
    const modalElement = document.getElementById('changepassword') as HTMLElement;
    if (modalElement) {
      modalElement.classList.remove('show');
      modalElement.setAttribute('aria-hidden', 'true');
      modalElement.style.display = 'none';
    }
  }
}
